import { Box, Typography, Button } from "@mui/material";
import './styles.css';
import React, { useState } from "react";
import CustomTextField from "../../components/CustomTextField";
import MultiSelectPrimary from "../../components/MultiSelectPrimary";
import Textarea from '@mui/joy/Textarea';
import { CssVarsProvider as JoyCssVarsProvider } from '@mui/joy/styles';
import GroundDetailsTable from "../../components/GroundDetailsTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import YenTextField from "../../components/YenTextField";
import CustomCurrencyTextField from "../../components/CustomCurrencyTextField";
import TrainingScheduleTable from "../../components/TrainingScheduleTable";
import CompetionsTable from "../../components/CompetionsTable";
import TitlesTable from "../../components/TitlesTable";
import { useTranslation } from "react-i18next";
import { isEmpty } from "../../common/StaticExports";
import AgeGroupSelect from "../../components/AgeGroupSelect";
import StaffSelect from "../../components/StaffSelect";
import StaffMultiSelectAutocomplete from "../../components/StaffMultiSelectAutocomplete";
import GroundSelectAutocomplete from "../../components/GroundSelectAutocomplete";
import { useDispatch, useSelector } from "react-redux";
import { saveTeamDetails } from "../../api/dataCapture";
import { di } from "@fullcalendar/core/internal-common";
import { setTeamDetails } from "../../redux/reducers/dataCaptures";

const AddTeamDetailsForm = (props:any) => {
    const { onCancelClick } = props;
    const [addCompetitions, setAddCompetitions] = useState(false);
    const [addTitles, setAddTitles] = useState(false);
    const teamList = useSelector((state:any) => state.dataCaptures.teamDetails);
    const clubDetails = useSelector((state:any) => state.clubDetails);
    const [t] = useTranslation();
    const [newTeam, setNewTeam]:any = useState({
        teamDetails: {
            id: null,
            teamName: '',
            established: 0,
            ageGroup: '',
            staffSupervisor: null,
            staffCoaches: [],
            staffGkCoaches: [],
            medicalStaff: [],
            practiceGrounds: []
        },
        playerAges: {
            u18: 0,
            u17: 0,
            u16: 0,
            u15: 0,
            u14: 0,
            u13: 0,
            u12: 0,
            u11: 0,
            u10: 0,
            u9: 0
        },
        trainingSchedule: {
            "mon": {
                "start": null,
                "end": null,
                "grounds": [],
                "remarks": ""
            },
            "tue": {
                "start": null,
                "end": null,
                "grounds": [],
                "remarks": ""
            },
            "wed": {
                "start": null,
                "end": null,
                "grounds": [],
                "remarks": ""
            },
            "thur": {
                "start": null,
                "end": null,
                "grounds": [],
                "remarks": ""
            },
            "fri": {
                "start": null,
                "end": null,
                "grounds": [],
                "remarks": ""
            },
            "sat": {
                "start": null,
                "end": null,
                "grounds": [],
                "remarks": ""
            },
            "sun": {
                "start": null,
                "end": null,
                "grounds": [],
                "remarks": ""
            }
        },
        teamFees: {
            admissionFees: '',
            playerMonthlyExpense: '',
            travelMonthlyExpense: '',
            remarks: ''
        },
        competitions: [],
        titles: []
    });

    const teamDetails = newTeam.teamDetails;
    const playerAges = newTeam.playerAges;
    const teamFees = newTeam.teamFees;
    const dispatch = useDispatch();

    
    const updateState = ((mainKey:any, key:any, updatedData:any) => {
        let updatedStaff:any = {};
        if (key == null) {
            updatedStaff = {
                ...newTeam,
                [mainKey]: updatedData,
            };
        } else {
            updatedStaff = {
                ...newTeam,
                [mainKey]: {
                    ...newTeam[mainKey],
                    [key]: updatedData,
                },
            };
        }
        setNewTeam(updatedStaff);
    });

    
    const createNewTeam = async () => {
        const updatedList = teamList ? [...teamList, newTeam] : [newTeam];
        saveTeamDetails({clubId: clubDetails?.id, data: updatedList})
        .then((response:any) => {
            dispatch(setTeamDetails(response));
            onCancelClick();
        });
    }

    return(
        <React.Fragment>
            <Box  className='mb20'>
                <Typography className='standardsHeading uppercase'>{t('DC_7_TEAM_DETAILS')}</Typography>
                <Box className='teamDetailsStyles'>
                    <CustomTextField label={t('DC_7_NAME')} value={teamDetails?.teamName} manageChange={(e:any) => { updateState('teamDetails', 'teamName', e) }} errorMessage={t('REQUIRED')} isError={isEmpty(teamDetails?.teamName)}/>
                    <CustomTextField type={'number'} label={t('DC_7_ESTABLISHED')} value={teamDetails?.established} manageChange={(e:any) => { updateState('teamDetails', 'established', parseInt(e)) }} errorMessage={t('REQUIRED')} isError={isEmpty(teamDetails?.established)}/>
                    <AgeGroupSelect 
                    label={t('DC_7_AGE_GROUP')} 
                    value={teamDetails?.ageGroup ? teamDetails?.ageGroup : ''}
                    manageSelect={(e:any) => { updateState('teamDetails', 'ageGroup', e) }}
                    isError={isEmpty(teamDetails?.ageGroup)}
                    errorMessage={t('REQUIRED')}/>
                    <StaffSelect
                    value={teamDetails?.staffSupervisor ? teamDetails?.staffSupervisor : ''}
                    manageSelect={(e:any) => { updateState('teamDetails', 'staffSupervisor', e) }}
                    label={t('DC_7_STAFF_SUPERVISOR')}
                    isError={isEmpty(teamDetails?.staffSupervisor)}
                    errorMessage={t('REQUIRED')}/>
                    <StaffMultiSelectAutocomplete 
                    selectedValues={teamDetails?.staffCoaches ? teamDetails?.staffCoaches : []}
                    manageSelect={(e:any) => { updateState('teamDetails', 'staffCoaches', e) }}
                    label={t('DC_7_STAFF_COACHES')}
                    isError={isEmpty(teamDetails?.staffCoaches)}
                    errorMessage={t('REQUIRED')}/>
                    <StaffMultiSelectAutocomplete 
                    selectedValues={teamDetails?.staffGkCoaches ? teamDetails?.staffGkCoaches : []}
                    manageSelect={(e:any) => { updateState('teamDetails', 'staffGkCoaches', e) }}
                    label={t('DC_7_STAFF_GK_COACHES')}
                    isError={isEmpty(teamDetails?.staffGkCoaches)}
                    errorMessage={t('REQUIRED')}/>
                    <StaffMultiSelectAutocomplete 
                    selectedValues={teamDetails?.medicalStaff ? teamDetails?.medicalStaff : []}
                    manageSelect={(e:any) => { updateState('teamDetails', 'medicalStaff', e) }}
                    label={t('DC_7_MEDICAL_STAFF')}
                    isError={isEmpty(teamDetails?.medicalStaff)}
                    errorMessage={t('REQUIRED')}/>
                    <GroundSelectAutocomplete 
                    selectedValues={teamDetails?.practiceGrounds ? teamDetails?.practiceGrounds : []}
                    manageSelect={(e:any) => { updateState('teamDetails', 'practiceGrounds', e) }}
                    label={t('DC_7_PRACTICE_GROUNDS')}
                    isError={isEmpty(teamDetails?.practiceGrounds)}
                    errorMessage={t('REQUIRED')}/>
                </Box>
            </Box>
            <Box  className='mb20'>
                <Typography className='standardsHeading uppercase'>{t('DC_7_PLAYER_AGES')}</Typography>
                <Box className='noPlayersStyles'>
                    <CustomTextField type={'number'} label='U-18' value={playerAges?.u18} manageChange={(e:any) => { updateState('playerAges', 'u18', parseInt(e)) }} errorMessage={t('REQUIRED')} isError={isEmpty(playerAges?.u18)}/>
                    <CustomTextField type={'number'} label='U-17' value={playerAges?.u17} manageChange={(e:any) => { updateState('playerAges', 'u17', parseInt(e)) }} errorMessage={t('REQUIRED')} isError={isEmpty(playerAges?.u17)}/>
                    <CustomTextField type={'number'} label='U-16' value={playerAges?.u16} manageChange={(e:any) => { updateState('playerAges', 'u16', parseInt(e)) }} errorMessage={t('REQUIRED')} isError={isEmpty(playerAges?.u16)}/>
                    <CustomTextField type={'number'} label='U-15' value={playerAges?.u15} manageChange={(e:any) => { updateState('playerAges', 'u15', parseInt(e)) }} errorMessage={t('REQUIRED')} isError={isEmpty(playerAges?.u15)}/>
                    <CustomTextField type={'number'} label='U-14' value={playerAges?.u14} manageChange={(e:any) => { updateState('playerAges', 'u14', parseInt(e)) }} errorMessage={t('REQUIRED')} isError={isEmpty(playerAges?.u14)}/>
                    <CustomTextField type={'number'} label='U-13' value={playerAges?.u13} manageChange={(e:any) => { updateState('playerAges', 'u13', parseInt(e)) }} errorMessage={t('REQUIRED')} isError={isEmpty(playerAges?.u13)}/>
                    <CustomTextField type={'number'} label='U-12' value={playerAges?.u12} manageChange={(e:any) => { updateState('playerAges', 'u12', parseInt(e)) }} errorMessage={t('REQUIRED')} isError={isEmpty(playerAges?.u12)}/>
                    <CustomTextField type={'number'} label='U-11' value={playerAges?.u11} manageChange={(e:any) => { updateState('playerAges', 'u11', parseInt(e)) }} errorMessage={t('REQUIRED')} isError={isEmpty(playerAges?.u11)}/>
                    <CustomTextField type={'number'} label='U-10' value={playerAges?.u10} manageChange={(e:any) => { updateState('playerAges', 'u10', parseInt(e)) }} errorMessage={t('REQUIRED')} isError={isEmpty(playerAges?.u10)}/>
                    <CustomTextField type={'number'} label='U-9' value={playerAges?.u9} manageChange={(e:any) => { updateState('playerAges', 'u9', parseInt(e)) }} errorMessage={t('REQUIRED')} isError={isEmpty(playerAges?.u9)}/>
                </Box>
            </Box>
            <Box  className='mb20'>
                <Typography className='standardsHeading uppercase'>{t('DC_7_TRAINING_SCHEDULE')}</Typography>
                <Box>
                    <TrainingScheduleTable
                    manageChange={(e:any) => { updateState('trainingSchedule', null, e) }} />
                </Box>
            </Box>
            <Box  className='mb20'>
                <Typography className='standardsHeading uppercase'>{t('DC_7_TEAM_FEES')}</Typography>
                <Box className='teamFeeStyles'>
                    <CustomCurrencyTextField label={'ADMISSION FEES (¥)'} variant='outlined' value={teamFees?.admissionFees} manageChange={(d:any) => updateState('teamFees','admissionFees', d)} errorMessage={t('REQUIRED')} isError={isEmpty(teamFees?.admissionFees)} />
                    <CustomCurrencyTextField label={'PLAYER MONTHLY EXPENSES (¥)'} variant='outlined' value={teamFees?.playerMonthlyExpense} manageChange={(d:any) => updateState('teamFees','playerMonthlyExpense', d)} errorMessage={t('REQUIRED')} isError={isEmpty(teamFees?.playerMonthlyExpense)} />
                    <CustomCurrencyTextField label={'TRAVEL MONTHLY EXPENSES (¥)'} variant='outlined' value={teamFees?.travelMonthlyExpense} manageChange={(d:any) => updateState('teamFees','travelMonthlyExpense', d)} errorMessage={t('REQUIRED')} isError={isEmpty(teamFees?.travelMonthlyExpense)} />
                    <CustomTextField label='Remarks' value={teamFees?.remarks} manageChange={(e:any) => { updateState('teamFees', 'remarks', e) }}/>
                </Box>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Box  className='mb20' sx={{ width: '45%' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                        <Typography className='standardsHeading uppercase'>{t('DC_7_LY_COMPETITIONS')}</Typography>
                        <Button className='smallButton' sx={{ float: 'right' }} disableElevation disabled={addCompetitions} variant='contained' size='small' onClick={() => {setAddCompetitions(true)}} startIcon={<FontAwesomeIcon icon={faPlus} />}>
                            {'Add competition'}
                        </Button>
                    </Box>
                    <Box>
                        <CompetionsTable 
                        addData={addCompetitions} 
                        handleClick={() => setAddCompetitions(false)}
                        manageState={(e:any) => { updateState('competitions', null, e) }} />
                    </Box>
                </Box>
                <Box  className='mb20' sx={{ width: '45%' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                        <Typography className='standardsHeading uppercase'>{t('DC_7_TITLES')}</Typography>
                        <Button className='smallButton' sx={{ float: 'right' }} disableElevation disabled={addTitles} variant='contained' size='small' onClick={() => {setAddTitles(true)}} startIcon={<FontAwesomeIcon icon={faPlus} />}>
                            {'Add title'}
                        </Button>
                    </Box>
                    <Box>
                        <TitlesTable 
                        addData={addTitles}
                        handleClick={() => setAddTitles(false)}
                        manageState={(e:any) => { updateState('titles', null, e) }}/>
                    </Box>
                </Box>
            </Box>
            <Box className={'mb20'} sx={{ display: 'flex', ml: 'auto', float: 'right', mb: '40px' }}>
                <Button className='smallButton closeCancelButtonStyles' variant='contained' sx={{ mr: 2 }} disableElevation disableRipple onClick={() => onCancelClick()}>Cancel</Button>
                <Button className='smallButton' variant='contained' disableElevation disableRipple onClick={() => {createNewTeam()}}>Add</Button>
            </Box>
        </React.Fragment>
    )
}

export default AddTeamDetailsForm;